export const PERMISSIONS = {
    ADMIN:'admin',
    PUBLIC: 'public',
    DASHBOARD: 'dashboard',
    DASHBOARD_V2: 'school-dashboard-v2',
    SETTINGS: 'settings',
    ACTIVITIES: 'activities',
    SCHOOL_PROFILE:'school-profile',

    // school permissions
    SCHOOL: 'school',
    SCHOOL_MODALITIES: 'school-modalities',
    SCHOOL_LEVELS: 'school-levels',
    SCHOOL_MEMBERS: 'school-members',
    SCHOOL_STUDENTS: 'school-students',
    SCHOOL_PRODUCTS: 'school-products',
    SCHOOL_BOOKINGS: 'school-bookings',
    SCHOOL_LESSONS: 'school-lessons',
    SCHOOL_STUDENT_EXCHANGE: 'school-student-exchange',
    SCHOOL_FINANCE: 'school-finance',
    SCHOOL_CASH: 'school-cash',

    SCHOOL_BOXES: 'school-boxes',

    // instructor
    INSTRUCTOR: 'instructor',
    INSTRUCTOR_LESSONS: 'instructor-lessons',

    // rentals
    RENTALS: 'rentals',                         // Owner + Manager: full access
    RENTALS_OPERATIONAL: 'rentals-operational', // Frontdesk: operational actions only
}